module.exports = __webpack_public_path__ + "media/117.5171f786.wav";